import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse } from '@/shared/types';
import { createApi } from '@reduxjs/toolkit/query/react';
import { PurchaseSummaryDto } from '@/pages/mortgage-workflow/types/purchase-summary.types';
import { RefinanceSummaryDto } from '../types/refinance-summary.types';

export const workbookApi = createApi({
  reducerPath: 'workbookApi',
  baseQuery: customBaseQuery,
  tagTypes: ['Workbook'],
  endpoints: (builder) => ({
    getPurchaseWorkbookBySheetId: builder.query<
      ApiResponse<PurchaseSummaryDto>,
      string
    >({
      query: (sheetId) => ({
        url: `/v1/mortgage/workbook/purchase/sheet/${sheetId}`,
        method: 'GET',
      }),
      transformResponse: (response: ApiResponse<PurchaseSummaryDto>) => {

        const additionalLenders = [
          { key: 'BLUESTONE', label: 'BlueStone', products: [{ code: 'BLUESTONE', label: 'BlueStone' }] },
          { key: 'BRIGHTEN', label: 'Brighten', products: [{ code: 'BRIGHTEN', label: 'Brighten' }] },
          { key: 'LA_THROBE', label: 'La Trobe', products: [{ code: 'LA_THROBE', label: 'La Trobe' }] },
        ];
        if (response.data?.lendersProducts) {
          response.data.lendersProducts = [
            ...response.data.lendersProducts,
            ...additionalLenders,
          ];
        }
        return response;
      },
      providesTags: (_res, _err, sheetId) => [
        { type: 'Workbook', id: sheetId },
      ],
    }),
    getRefinanceWorkbookBySheetId: builder.query<
      ApiResponse<RefinanceSummaryDto>,
      string
    >({
      query: (sheetId) => ({
        url: `/v1/mortgage/workbook/refinance/sheet/${sheetId}`,
        method: 'GET',
      }),
      providesTags: (_res, _err, sheetId) => [
        { type: 'Workbook', id: `refinance-${sheetId}` },
      ],
    }),
  }),
});
export const {
  useGetPurchaseWorkbookBySheetIdQuery,
  useLazyGetPurchaseWorkbookBySheetIdQuery,

  useGetRefinanceWorkbookBySheetIdQuery,
  useLazyGetRefinanceWorkbookBySheetIdQuery,
} = workbookApi;
